import { initializeApp } from "firebase/app";
import { getMessaging, onMessage } from "firebase/messaging";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";
const firebaseConfig = {
  apiKey: "AIzaSyAyWN6Q0Yv4fHoIPBgD-8E1aNAZPQijouY",
  authDomain: "niyama-e72a3.firebaseapp.com",
  projectId: "niyama-e72a3",
  storageBucket: "niyama-e72a3.appspot.com",
  messagingSenderId: "93958639689",
  appId: "1:93958639689:web:5542a0557483af4585af98",
  measurementId: "G-ER9CRL7DWL",
};

export const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);
export const db = getFirestore(app);
export const rdb = getDatabase(app);
export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      // console.log("payload", payload)
      resolve(payload);
    });
  });
